<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <div class="flex sm:justify-center text-30px sm:font-rhetorik-sans sm:text-40px">Your Upcoming Tours</div>
      <div class="flex sm:justify-center px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl mt-2">Below please find your
        upcoming self tours and agent guided tours with Tricon.</div>
    </div>
  </div>
  <div class="sm:w-auto flex justify-center">
    <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-8">
      <div *ngFor="let tour of tourCards">
        <div *ngIf="tour.PropViewCard !== undefined && tour.PropViewCard.sqft !== null"
          class="my-4 flex justify-center flex-col">
          <div class="grid grid-cols-5fr-1fr grid-rows-1fr-4fr">
            <img class="rounded w-full h-auto max-w-500px z-0 col-start-1 col-end-3 row-start-1 row-end-3"
              src={{tour.PropViewCard.thumb}}>
            <div
              class="tracking-wider font-medium tour-datetime-banner-font h-5 bg-true-blue col-start-1 col-end-2 z-10 row-start-1 row-end-2 flex self-start justify-self-start text-white px-3 rounded-tl-br-sm">
              <div class="flex my-auto">{{tour.TourMonth}} {{tour.TourDay}} </div>
              <div class="flex mx-1 my-auto"> @ </div>
              <div class="flex my-auto">{{tour.TourTime}}</div>
            </div>
          </div>
          <div *ngIf="!tour.PropViewCard.IsMF"
            class="flex flex-row justify-between items-baseline justify-items-center">
            <div *ngIf="!tour.DefaultCard" class="flex text-2xl font-bold items-baseline">
              ${{tour.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
            </div>
            <div class="flex flex-row justify-evenly text-lg">
              <div *ngIf="!tour.DefaultCard" class="flex text-black">{{tour.PropViewCard.beds}}<span
                  class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!tour.DefaultCard" class="flex ml-1 text-black">{{tour.PropViewCard.baths}}<span
                  class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!tour.DefaultCard" class="flex ml-1 text-black">{{tour.PropViewCard.sqft}}<span
                  class="text-gray-tricon ml-1">sqft</span></div>
            </div>
          </div>
          <div *ngIf="tour.IsMF" class="text-2xl sm:text-lg">
            {{tour.MarketingName}}
          </div>
          <div *ngIf="!tour.PropViewCard.IsMF" class="text-2xl sm:text-lg">
            {{tour.AddressLine1}} {{tour.City}}, {{tour.State}} {{tour.PropViewCard.zip}}
          </div>
          <div class="flex w-full flex-wrap lg:justify-between xl:justify-start my-4 sm:my-0">
            <div class="mr-8 lg:mr-0 xl:mr-8 mt-2">
              <button *ngIf="tour.CardType === 'SelfTour'" class="text-base sm:text-sm font-normal" mat-button
                color="accent" (click)="openSelfTourCalendarDialog(tour)">ADD TO CALENDAR</button>
              <button *ngIf="tour.CardType !== 'SelfTour'" class="text-base sm:text-sm font-normal" mat-button
                color="accent" (click)="openTourCalendarDialog(tour)">ADD TO CALENDAR</button>

            </div>
            <div class="mr-8 lg:mr-0 xl:mr-8 mt-2">
              <button class="text-base sm:text-sm font-normal" mat-button color="accent" (click)="viewHome(tour)">VIEW
                LISTING</button>
            </div>
            <div class="mt-2">
              <button *ngIf="tour.CardType === 'OpenHouse'" class="text-base sm:text-sm font-normal" mat-button
                color="accent" (click)="cancelTour(tour)">CANCEL OPEN HOUSE</button>
              <button *ngIf="tour.CardType === 'Showing'" class="text-base sm:text-sm font-normal" mat-button
                color="accent" (click)="cancelTour(tour)">CANCEL AGENT TOUR</button>
            </div>
          </div>
          <button *ngIf="tour.CardType === 'SelfTour' && !tour.Disabled" mat-flat-button color="primary"
            class="my-4 font-normal text-2xl sm:text-base" (click)="startSelfTour(tour)">START SELF TOUR</button>
        </div>
      </div>
    </div>
  </div>
  <app-map *ngIf="isLoaded" class="flex" [mapLocations]="mapLocations"></app-map>
</div>
